import PropTypes from 'prop-types';
import React from 'react';
import RCUIBadge from '../../../../shared/components/RCUIBadge';
import styles from './Header.scss';
import Filters from './Filters';
import RefinementContentContainer from './RefinementContentContainer';
import RefinementTitle from './RefinementTitle';
import RefinementButton from './RefinementButton';

const RefinementsHeader = ({
  channelObject,
  location,
  extraLocalitiesCount,
  propertyTypesString,
  priceString,
  areaString,
  openRefinements,
}) => (
  <RefinementContentContainer
    className={styles.filterContainer}
    onClick={openRefinements}
    ariaLabel={`Open refinements for ${channelObject.shortHumanReadable}`}
  >
    <RefinementTitle>
      <div className={`${styles.icon} rui-icon rui-icon-search-small`} />
      <div className={`${styles.titleMain} text-truncate`}>
        <span className={styles.titleMainBuy}>
          <span>{channelObject.shortHumanReadable}</span>
          <span className={styles.divider} />
        </span>
        <span className={styles.textWrapper}>
          <span className={`${styles.locationText} text-truncate`}>{location}</span>
          {extraLocalitiesCount > 0 &&
            <RCUIBadge text={`+${extraLocalitiesCount}`} type="dark" classNames={styles.badge} />}
          <span className={styles.desktopFilters}>
            <Filters {...{ propertyTypesString, priceString, areaString }} />
          </span>
        </span>
      </div>
    </RefinementTitle>
    <div className={`${styles.titleSub} text-truncate`}>
      <span className={styles.titleSubBuy}>
        <span>{channelObject.shortHumanReadable}</span>
      </span>
      <Filters {...{ propertyTypesString, priceString, areaString }} />
    </div>
    <RefinementButton
      mVisibleText="Refine Search"
      xVisibleText="Refine"
    />
  </RefinementContentContainer>
);

RefinementsHeader.propTypes = {
  channelObject: PropTypes.shape({
    shortHumanReadable: PropTypes.string,
  }),
  location: PropTypes.string,
  extraLocalitiesCount: PropTypes.number,
  propertyTypesString: PropTypes.string,
  priceString: PropTypes.string,
  areaString: PropTypes.string,
  openRefinements: PropTypes.func.isRequired,
};

export default RefinementsHeader;
